import { useEffect, useRef, useState } from 'react'
import type { RawDraftContentBlock } from 'draft-js'
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'

interface TextViewDraftJSProps {
  text: string
  showSeeMoreButton?: boolean
}

export function TextViewDraftJSSEO({
  text,
  showSeeMoreButton = true,
}: Readonly<TextViewDraftJSProps>) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const draftState = EditorState.createWithContent(
    convertFromRaw(JSON.parse(text))
  )

  const rawContent = convertToRaw(draftState.getCurrentContent())

  rawContent.blocks = rawContent.blocks.map((block: RawDraftContentBlock) => {
    if (block.type === 'section') {
      return { ...block, type: 'unstyled' }
    }

    return block
  })

  const textHtml = draftToHtml(rawContent)
  const isCollapsed = showSeeMoreButton && showButton && !isExpanded

  useEffect(() => {
    if (!showSeeMoreButton) {
      setShowButton(false)

      return
    }

    const el = contentRef.current

    if (!el) {
      setShowButton(false)

      return
    }

    const style = getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight || '0')
    const maxHeight = lineHeight

    setShowButton(
      el.scrollHeight > maxHeight + 1 || el.scrollWidth > el.clientWidth + 1
    )
  }, [showSeeMoreButton, textHtml])

  return (
    <div className="text-view-seo">
      {isCollapsed ? (
        <div className="flex items-baseline">
          <div
            ref={contentRef}
            className="text-view-html flex-1 min-w-0 md:max-w-[15%] overflow-hidden [display:-webkit-box] [-webkit-line-clamp:1] [-webkit-box-orient:vertical] text-sm text-secondary font-inter font-normal leading-[21px] [&>p]:m-0"
            dangerouslySetInnerHTML={{ __html: textHtml }}
          />
          <button
            type="button"
            className="ml-1 shrink-0 inline-flex text-[14px] leading-[21px] font-medium text-[#222] underline underline-offset-[2px] decoration-[0.8px]"
            onClick={() => setIsExpanded(true)}
          >
            Ver mais
          </button>
        </div>
      ) : (
        <>
          <div
            ref={contentRef}
            className="text-view-html text-sm text-secondary font-inter font-normal leading-[21px]"
            dangerouslySetInnerHTML={{ __html: textHtml }}
          />

          {showSeeMoreButton && showButton && (
            <button
              type="button"
              className="mt-1 inline-flex text-[14px] leading-[21px] font-medium text-[#222] underline underline-offset-[2px] decoration-[0.8px]"
              onClick={() => setIsExpanded(false)}
            >
              Mostrar menos
            </button>
          )}
        </>
      )}
    </div>
  )
}
